import React from "react";

import { Badge } from "components/badge/Badge";

import { getTagBadgeColours } from "./creditBooksFilterUtils";

import "./creditBookCustomerTagBadge.scss";

interface IProps {
  label: string;
  colour?: string;
}

export default function CreditBookCustomerTagBadge(props: IProps) {
  const { label, colour } = props;
  const { textColour, borderColour, backgroundColour } = getTagBadgeColours(colour);

  return (
    <span
      className="credit-book-customer-tag-badge"
      style={
        {
          "--credit-book-tag-text": textColour,
          "--credit-book-tag-border": borderColour,
          "--credit-book-tag-background": backgroundColour,
        } as React.CSSProperties
      }
    >
      <Badge outline colour={textColour} backgroundColour={backgroundColour} size="small">
        {label}
      </Badge>
    </span>
  );
}
